import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Auth0Provider } from './react-auth0-spa';
import history from './utils/history';
import './assets/scss/app.scss';
import { AUTH0_CLIENT_ID, DOMAIN, RBAC_AUD } from './config';

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={DOMAIN}
    client_id={AUTH0_CLIENT_ID}
    audience={RBAC_AUD}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
);
